import { create } from 'zustand';

// RESTRICTED_MCC_CODES now contains IDs, not codes. Comments show code and label for clarity.
const RESTRICTED_MCC_CODES = [
  1, // 0420 Cannabis/Dispensary/Marijuana
  2, // 0421 Kratom
  // 5967 Adult Streaming Video, Porn
  838,
  839,
  840,
  841,
  842,
  843,
  844,
  845,
  846,
  847,
  // 5968 Nude or Porn
  850,
  851,
  852,
  853,
  854,
  855,
  879, // 5977 CBD / HEMP TOPICAL
  // 5912 CBD / HEMP INGESTIBLE
  726,
  727,
  728,
  729,
  730,
  731,
  // 5993 CBD – Vape
  899,
  900,
  901,
  902,
  903,
  904,
  905,
  906,
  907,
  908,
  909,
  910,
  911,
  912,
  // 5122 Pharmaceuticals, HGH (only peptide special case allowed)
  1736, // 5122 Peptide Products (special case: allow if peptide fields are true)
  // 8299 Essay Mills / Paper Mills
  1602,
  1603,
  1604,
  1605,
  1606,
  1607,
  1609,
  1610,
  1611,
  1612,
  1613,
  1614,
  1615,
  1616,
  1617,
  1618,
  1619,
  1620,
  1622,
  676, // 5734 Modification Chips, Unlicensed Intellectual Property
  // 7995 Betting, Gambling, Patently Offensive Material
  1433,
  1434,
  1435,
  1436,
  1437,
  1438,
  1439,
  1440,
  1441,
  // 7399 Selling as an Agent for a Third Party
  1254,
  1255,
  1256,
  1257,
  1258,
  1259,
  1260,
  1261,
  1262,
  1263,
  1264,
  1265,
  1266,
  1267,
  1268,
  1269,
  1270,
  1271,
  1272,
  1273,
  1274,
  1275,
  1276,
  1277,
  // 5999 Miscellaneous Retail (Potentially Counterfeit Goods)
  933,
  934,
  935,
  936,
  937,
  939,
  940,
  941,
  942,
  944,
  945,
  946,
  947,
  948,
  949,
  950,
  951,
  952,
  953,
  954,
  955,
  956,
  957,
  958,
];

interface RestrictedMccState {
  restrictedMccIds: number[];
}

const useRestrictedMccStore = create<RestrictedMccState>((set) => ({
  restrictedMccIds: RESTRICTED_MCC_CODES,
}));

export default useRestrictedMccStore;
